module.exports = __webpack_public_path__ + "img/footer-1.5598482a.svg";